import { render, staticRenderFns } from "./forbidden.template.vue?vue&type=template&id=72e34409&scoped=true&"
var script = {}
import style0 from "./forbidden.template.vue?vue&type=style&index=0&id=72e34409&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e34409",
  null
  
)

export default component.exports